<template>
  <div
    class="rounded-lg bg-gray-50 p-2 text-sm dark:bg-kekkle-dark"
    :class="sizeClasses"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "DescriptionBox",
  props: {
    size: {
      type: String,
      default: "md",
      validator: (value) => ["sm", "md", "lg"].includes(value),
    },
  },
  computed: {
    sizeClasses() {
      switch (this.size) {
        case "sm":
          return "p-1.5 text-xs";
        case "lg":
          return "p-3 text-base";
        case "md":
        default:
          return "p-2 text-sm";
      }
    },
  },
};
</script>
